import { useEffect, useState } from 'react';

import { GOLOCKER_BRAND } from '../../utils/goLocker';

import styles from './GoLocker.module.scss';

const SIZE_CLASSES = {
  card: styles.markCard,
  band: styles.markBand,
  heading: styles.markHeading,
  box: styles.markBox,
};

/**
 * GoLockerMark — the GoLocker logo at the size each surface draws it.
 *
 *   variant 'color'   — green "Go" on light surfaces (option card, kiosk card)
 *   variant 'reverse' — knock-out for the green band / QR sheet / carousel heading
 *
 * `logoUrl` wins over the bundled asset: for the colour mark that is the method's
 * `configuration.icon` (product changes the logo from configuration); for the reverse
 * one a configured dropOffBand.logoUrl. The bundled Figma asset is only the fallback
 * — when the field is missing, or the remote file fails to load.
 */
const GoLockerMark = ({ variant = 'color', size = 'card', logoUrl }) => {
  const bundled = variant === 'reverse' ? GOLOCKER_BRAND.logoReverse : GOLOCKER_BRAND.logo;
  const [failed, setFailed] = useState(false);
  useEffect(() => { setFailed(false); }, [logoUrl]);

  return (
    <img
      src={logoUrl && !failed ? logoUrl : bundled}
      alt={GOLOCKER_BRAND.name}
      className={SIZE_CLASSES[size] ?? styles.markCard}
      onError={logoUrl && !failed ? () => setFailed(true) : undefined}
    />
  );
};

export default GoLockerMark;
